import api from '../services/api';
import { querystring } from '../utils/resposta';

const Usuario = {
  model : {nome: '', email: '', estado: '', cidade: '', celular: '', senha: '', confirmar_senha: '', termo: ''},
  
  login : async function (usuario) {
    return await api.post(`/login`, usuario)
    .then(response=>response)
    .catch(error=>error);
  },

  findSearch : async function (search, page=1) {
    search = search ? search : ' ';
    return await api.get(`/usuarios/data/${search}/${page}/8`)
    .then(response=>response)
    .catch(error=>error);
  },

  addMidia : async function (data) {
    return await api.post(`/usuarios/add/midia`, data)
    .then(response=>response)
    .catch(error=>error);
  },

  alterarSenha : async function (data) {
    return await api.post(`/usuarios/alterar-senha`, data)
    .then(response=>response)
    .catch(error=>error);
  },

  solicitarRedefinirSenha : async function (data) {
    return await api.post(`/usuarios/redefinir-senha/solicitacao`, data)
    .then(response=>response)
    .catch(error=>error);
  },

  redefinirSenha : async function (data) {
    return await api.post(`/usuarios/redefinir-senha`, data)
    .then(response=>response)
    .catch(error=>error);
  },


  findById : async function (id) {
    return await api.get(`usuarios/id/${id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  create : async function (data) {
    if(!data.sobre){
      data.sobre = "";
    }
    delete data.foto_perfil;
    delete data.foto_capa;
    // Conta sem telefone/cidade/estado vem com null do servidor e a validacao do
    // backend (Joi.string) recusa null: salvar QUALQUER dado dava 'O campo Celular
    // deve ser uma string'. Vazio e aceito.
    for (const campo of ['celular', 'cidade', 'estado']) {
      if (data[campo] === null || data[campo] === undefined) data[campo] = '';
    }
    return await api.post(`usuarios`, data)
    .then(response=>response)
    .catch(error=>error);
  },

  delete : async function (usuario_id) {
    return await api.delete(`usuarios/id/${usuario_id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  sendEmail : async function (usuario_id) {
    return await api.post('usuarios/email-confirmacao', {usuario_id})
    .then(response=>response)
    .catch(error=>error);
  },

  // Troca de e-mail com validacao do NOVO endereco (o e-mail antigo vale ate confirmar).
  solicitarTrocaEmail : async function (novo_email) {
    return await api.post('usuarios/email/solicitar-troca', {novo_email})
    .then(response=>response)
    .catch(error=>error);
  },

  confirmarTrocaEmail : async function (codigo) {
    return await api.post('usuarios/email/confirmar-troca', {codigo})
    .then(response=>response)
    .catch(error=>error);
  },

  cancelarTrocaEmail : async function () {
    return await api.post('usuarios/email/cancelar-troca')
    .then(response=>response)
    .catch(error=>error);
  },

  confirmEmail : async function (usuario_id, codigo) {
    return await api.post('usuarios/validar-codigo', {usuario_id, codigo})
    .then(response=>response)
    .catch(error=>error);
  },

  // Administrador: lista TODOS os status (a busca comum só traz Ativo, o que
  // faria o usuário desativado sumir do painel sem como reativá-lo).
  findAdminLista : async function (page = 1, limit = 10, filtros = {}) {
    return await api.get(`/usuarios/admin/lista/${page}/${limit}${querystring(filtros)}`)
    .then(response=>response)
    .catch(error=>error);
  },

  // O proprio Profissional deixa o perfil na hora (sem aprovacao). Alvo: usuario autenticado.
  deixarProfissional : async function () {
    return await api.post('usuarios/deixar-profissional')
    .then(response=>response)
    .catch(error=>error);
  },

  alterarTipo : async function (usuario_id, tipo) {
    return await api.patch(`/usuarios/${usuario_id}/tipo`, { tipo })
    .then(response=>response)
    .catch(error=>error);
  },

  alterarStatus : async function (usuario_id, status) {
    return await api.patch(`/usuarios/${usuario_id}/status`, { status })
    .then(response=>response)
    .catch(error=>error);
  },

  findGraph : async function (fromDate, toDate, userType) {
    return await api.get(`/usuarios/graph/data/${fromDate}/between/${toDate}/tipo-usuario/${userType}`)
    .then(response=>response)
    .catch(error=>error);
  },
}

export default Usuario;